export default "__VITE_ASSET__BznF924s__"